import React from 'react';
import { WebComponentRenderer } from '../../../../angular-in-react/WebComponentRenderer';
import { WizardStepBaseProps } from '../../../../wizard/interfaces/wizardStep';
import { useWizardStepData } from '../../../../wizard/hooks/useWizardStepData';
import { Target } from '../../../activate-target/models/target';
import { TargetObjectMeta } from '../../../activate-target/models/target-object-meta';

export interface FieldsMappingAngularInReactProps {
  data: any;
  warehouse: any;
  target: Target;
  warehouseQuery: string;
  targetObjectSelectedFromExplorer: TargetObjectMeta;
  activationNameChange: (name: string) => any;
  continue: (data: any) => any;
}

export function FieldsMappingStep({
  initialData,
  controller,
  completeStep,
  onDataChange,
  markDirty
}: WizardStepBaseProps) {
  const [data, setData] = useWizardStepData(initialData, onDataChange);

  const activationNameChange = (name: string) => {
    setData({
      ...data,
      activationName: name
    });
  };

  const onContinue = ({ activationMappingConfig, mappingData, warehouseFields }) => {
    if (!data.mappingSettings || !data.activationName) {
      markDirty();
    }

    setData({
      ...data,
      mappingSettings: activationMappingConfig,
      mapping: mappingData,
      warehouseFields
    });

    completeStep();
  };

  return (
    <WebComponentRenderer
      elementSelector='activation-fields-mapping-web-component'
      {...({
        data,
        warehouse: controller.data['destinationSettings'],
        target: controller.data['targetSettings'],
        warehouseQuery: controller.data['query'],
        targetObjectSelectedFromExplorer: controller.data['selectedTargetObject'],
        activationNameChange,
        continue: onContinue
      } as FieldsMappingAngularInReactProps)}
    >
      {/* @ts-ignore */}
      <activation-fields-mapping-web-component></activation-fields-mapping-web-component>
    </WebComponentRenderer>
  );
}
